import { Button } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React, { useEffect, useState } from 'react';
import { Check, X } from 'tabler-icons-react';
import { Entity } from '../../enums/entity.enums';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { EnableDisableButtonData } from '../../type/button.types';
import { EnableEntitiesRequest } from '../../type/entity.types';
import { ErrorResponse } from '../../type/error-response.types';
import DisabledModal from '../admin-entities/admin-entity-manager/components/disabled-modal.component';

interface Props {
  isChecked: number[];
  data: EnableDisableButtonData[] | undefined;
  setRefreshTable: React.Dispatch<React.SetStateAction<boolean>>;
}

const getEntityType = (entity?: Entity) => {
  if (entity === Entity.PARTNER) {
    return 'partner';
  } else if (entity === Entity.MERCHANT) {
    return 'merchant';
  } else if (entity === Entity.RESELLER) {
    return 'reseller';
  } else if (entity === Entity.BRANCH) {
    return 'branch';
  } else {
    return 'item';
  }
};

function DisableButton(props: Props) {
  const { isChecked, data, setRefreshTable } = props;
  const [disableDisable, setDisableDisable] = useState(true);
  const [loadingDisable, setLoadingDisable] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [isDisabledModalOpen, setisDisabledModalOpen] = useState(false);

  const entityName = getEntityType(data ? data[0]?.entityType : undefined);

  const getEntityName = (): string => {
    let name = 'item';

    if (data) {
      if (isChecked?.length > 1) {
        name =
          data[0].entityType === Entity.BRANCH
            ? entityName + 'es'
            : entityName + 's';
      } else if (isChecked?.length === 1) {
        const selectedEntity = data.find(
          (item) => item.entityId === isChecked[0]
        );
        name = selectedEntity?.entityName ?? 'item';
      }
    }

    return name;
  };

  useEffect(() => {
    setDisableDisable(false);

    if (data === undefined) {
      setDisableDisable(true);
      return;
    }

    if (isChecked.length === 0) {
      setDisableDisable(true);
    }
    if (isChecked.length > 0) {
      data?.forEach((item) => {
        if (isChecked.includes(item.entityId)) {
          if (!item.isActive) {
            setDisableDisable(true);
          }
        }
      });
    }
  }, [isChecked, data]);

  const handleDisable = async (disableReason: string) => {
    if (data?.length === 0) {
      return;
    }
    setLoadingDisable(true);

    const request: EnableEntitiesRequest = {
      entityIds: isChecked,
      entityType: data![0].entityType,
      newActiveStatus: false,
      disabledReason: disableReason,
    };

    try {
      await axiosPrivate.post('/web/entities/enable', request);
      showNotification({
        id: 'successfully-disabled-accounts',
        message: 'Successfully disabled selected account/s',
        icon: <Check size={16} />,
        color: 'teal',
        autoClose: 6000,
      });

      setRefreshTable((prev) => {
        return !prev;
      });
    } catch (err: any) {
      const error: ErrorResponse = err.response?.data;
      showNotification({
        id: 'failed-to-disable-account',
        message: error.error || 'An Unexpected Error Occurred',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000,
      });
    } finally {
      setLoadingDisable(false);
    }
  };

  return (
    <>
      <DisabledModal
        handleClose={() => setisDisabledModalOpen(false)}
        isDisabledModalOpen={isDisabledModalOpen}
        disableFunction={handleDisable}
        disableTitle={entityName}
        disableName={getEntityName()}
      />
      <Button
        color='red'
        disabled={disableDisable}
        onClick={() => setisDisabledModalOpen(true)}
        loading={loadingDisable}
      >
        DISABLE
      </Button>
    </>
  );
}

export default DisableButton;
